module.exports = __webpack_public_path__ + "static/media/checkbox-filled.67e1a254.svg";